import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import app from "./reducers";
import MCSMainContainer from "./Containers/mcs.maincontainer";
import 'react-circular-progressbar/dist/styles.css';
import "./Style/module-import.scss";

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
const store = createStore(app, preloadState, applyMiddleware(thunk));

let mcsPanelRef = document.getElementById("MCS panel");
if (mcsPanelRef) {
    ReactDOM.render(
        <Provider store={store}>
            <MCSMainContainer />
        </Provider>,
        mcsPanelRef
    );
}